export var CustomListKey;
(function (CustomListKey) {
    CustomListKey["ClientStatus"] = "ClientStatus";
    CustomListKey["HomeCareLeadStatus"] = "HomeCareLeadStatus";
})(CustomListKey || (CustomListKey = {}));
//# sourceMappingURL=custom-list.js.map